import { render } from "./TurntableSelector.vue?vue&type=template&id=7474dadc"
import script from "./TurntableSelector.vue?vue&type=script&lang=js"
export * from "./TurntableSelector.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__